import { SubjectType } from '../enums/subject-type.enum';
import { WorkflowArea } from '../enums/workflow-area.enum';
import { workflowSectionsToCreateDto } from './workflow-sections-to-create-dto.interface';

export interface CreateWorkflowDto {
    name: string;
    area: WorkflowArea;
    /** REV-22155 — missing = COMPANY. */
    subjectType?: SubjectType;
    sectionsToCreate: workflowSectionsToCreateDto[];
}
